import React, { useState } from 'react'

export const VolunteerForm = () => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');
    const [interest, setInterest] = useState('');
    const [message, setMessage] = useState('');

    return (
        <form>
            <div className="slope-contact-form" style={{ marginTop: '100px' }}>
                <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Volunteer Form</h2>
                <div className="fields-wrapper" style={{ width: '100%', marginLeft: 0, paddingLeft: 0 }}>
                    <div className="input-contact" style={{ width: '100%', marginLeft: 0, paddingLeft: 0 }}>
                        <span className="wpcf7-form-control-wrap name-field" style={{ width: '100%', marginLeft: 0, paddingLeft: 0 }}>
                            <input
                                type="text"
                                name="name"
                                placeholder="Your name *"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                style={{ width: '100%', marginLeft: 0, paddingLeft: 0 }}
                            />
                        </span>
                        <span className="wpcf7-form-control-wrap email-field" style={{ width: '100%', marginLeft: 0, paddingLeft: 0 }}>
                            <input
                                type="email"
                                name="email"
                                placeholder="Email address *"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                style={{ width: '100%', marginLeft: 0, paddingLeft: 0 }}
                            />
                        </span>
                        <span className="wpcf7-form-control-wrap number-field" style={{ width: '100%', marginLeft: 0, paddingLeft: 0 }}>
                            <input
                                type="tel"
                                name="phone"
                                placeholder="Phone"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                style={{ width: '100%', marginLeft: 0, paddingLeft: 0 }}
                            />
                        </span>
                        <span className="wpcf7-form-control-wrap address-field" style={{ width: '100%', marginLeft: 0, paddingLeft: 0 }}>
                            <input
                                type="text"
                                name="address"
                                placeholder="Your Address *"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                style={{ width: '100%', marginLeft: 0, paddingLeft: 0 }}
                            />
                        </span>
                        <span className="wpcf7-form-control-wrap interest-field" style={{ width: '100%', marginLeft: 0, paddingLeft: 0 }}>
                            <input
                                type="text"
                                name="interest"
                                placeholder="Area of interest *"
                                value={interest}
                                onChange={(e) => setInterest(e.target.value)}
                                style={{ width: '100%', marginLeft: 0, paddingLeft: 0 }}
                            />
                        </span>
                    </div>
                    <div className="textarea-contact" style={{ width: '100%', marginLeft: 0, paddingLeft: 0 }}>
                        <span className="wpcf7-form-control-wrap message-field" style={{ width: '100%', marginLeft: 0, paddingLeft: 0 }}>
                            <textarea
                                name="message"
                                cols="40"
                                rows="10"
                                placeholder="Why would you like to volunteer with us? *"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                style={{ width: '100%', marginLeft: 0, paddingLeft: 0 }}
                            ></textarea>
                        </span>
                    </div>
                </div>
                <div className="submit-contact">
                    <input type="submit" value="Submit" />
                </div>
            </div>
        </form>
    )
}
